import { render, staticRenderFns } from "./SingleRecipientList.vue?vue&type=template&id=34907841&scoped=true"
import script from "./SingleRecipientList.vue?vue&type=script&lang=js"
export * from "./SingleRecipientList.vue?vue&type=script&lang=js"
import style0 from "./SingleRecipientList.vue?vue&type=style&index=0&id=34907841&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34907841",
  null
  
)

export default component.exports